module.exports = __webpack_public_path__ + "static/img/framework.3c42fa0f.png";